export default __webpack_public_path__ + "static/media/108.104800d2.png";